(() => {
  const STORAGE_KEY = 'filo-opening-loader';
  const loader = document.querySelector('[data-opening-loader]');
  const word = loader?.querySelector('[data-loader-word]');

  if (!loader || !word) return;

  const root = document.documentElement;

  const skipLoader = () => {
    loader.remove();
  };

  if (window.__filoShowOpeningLoader === false) {
    skipLoader();
    return;
  }

  const markLoaderShown = () => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          timestamp: Date.now(),
        })
      );
    } catch (error) {
      // Ignore storage failures (private browsing, quota, etc.)
    }
  };

  loader.hidden = false;
  markLoaderShown();

  // Signal CSS to hide page content so we can animate it in
  root.classList.add('filo-page-entering');

  // "Filo" in each Indian language (in specified order)
  const words = [
    'फिलो',   // Hindi
    'ફિલો',   // Gujarati
    'फिलो',   // Marathi
    'ফিলো',   // Bengali
    'ਫਿਲੋ',   // Punjabi
    'ஃபிலோ',  // Tamil
    'ఫిలో',   // Telugu
    'ಫಿಲೋ',   // Kannada
    'ഫിലോ',   // Malayalam
    'ଫିଲୋ',   // Odia
    'ফিলো',   // Assamese
    'فیلو',   // Urdu
    'फिलः',   // Sanskrit
    'फिलो',   // Konkani
    'ꯐꯤꯂꯣ',  // Manipuri
    'फिलो',   // Nepali
    'فیلو',   // Kashmiri
    'فيلو',   // Sindhi
  ];

  const interval = 135; // ms between each word
  let index = 0;

  const closeLoader = () => {
    // Fade out the loader overlay
    loader.classList.add('is-hidden');

    // Trigger CSS page entrance animation
    root.classList.remove('filo-loader-pending');
    root.classList.add('filo-loader-seen');

    // Remove from DOM after transition finishes (fallback timer matches longest CSS transition)
    const removeFallback = window.setTimeout(() => loader.remove(), 2000);

    loader.addEventListener(
      'transitionend',
      (event) => {
        if (event.target !== loader) return;
        window.clearTimeout(removeFallback);
        loader.remove();
      },
      { once: true }
    );
  };

  const nextWord = () => {
    if (index >= words.length) {
      closeLoader();
      return;
    }

    word.textContent = words[index];
    index += 1;

    window.setTimeout(nextWord, interval);
  };

  // Start immediately — no initial delay
  nextWord();
})();
